var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home font-montserrat font-light antialised h-full flex flex-col"},[_c('HeaderPartners',{attrs:{"header-partners-data":_vm.HeaderPartners}}),_c('main',[_c('Services',{attrs:{"ServiceData":_vm.services}}),_c('Experiences',{attrs:{"ExperiencesData":_vm.experiences}}),_vm._m(0),_c('div',{staticClass:"w-full overflow-hidden pt-16"},[_c('carousel',{staticClass:"container mx-auto",attrs:{"nav":false,"margin":30,"responsive":{0 : {
            items : 1,
          },
          576 : {
            items : 2,

          },
          768 : {
            items : 2,
          },
          992 : {
            items : 2,
          },
          1200 : {
            items : 3,
          }}}},_vm._l((_vm.projects),function(project){return _c('FeaturedProject',{key:project.id,attrs:{"dataProject":project}})}))],1),_c('Location',{attrs:{"location-data":_vm.location}})],1),_c('FooterItem')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto leading-normal px-4 mt-8"},[_c('div',{staticClass:"pt-8"},[_c('h3',{staticClass:"font-oswald italic text-dark text-2xl md:text-3xl xl:text-4xl"},[_vm._v("Referencias"),_c('span',{staticClass:"ml-4 skew inline-block bg-primary w-3 h-7"})])])])}]

export { render, staticRenderFns }